export const svgWidthLg = 673;
export const svgWidthSm = 240;
export const classNameLg = 'hidden overflow-visible h-auto max-w-full @md:block';
export const classNameSm = 'h-auto overflow-visible max-w-full @md:hidden';
